import { create } from 'zustand';

interface NotificationCenterState {
  isOpen: boolean;
  isPreferencesOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  openPreferences: () => void;
  closePreferences: () => void;
}

export const useNotificationCenterStore = create<NotificationCenterState>(
  (set) => ({
    isOpen: false,
    isPreferencesOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
    openPreferences: () => set({ isPreferencesOpen: true }),
    closePreferences: () => set({ isPreferencesOpen: false }),
  }),
);
